import QRCodeStyling from 'qr-code-styling';

/**
 * Genera un QR code come data URL PNG.
 *
 * Serve un PNG (non un SVG) perché jsPDF accetta solo immagini raster: è il
 * motivo per cui questa util esiste accanto a StyledQrCode.tsx, che invece
 * renderizza SVG per la UI del modulo QR Codes.
 *
 * Usa qr-code-styling, già in dipendenze — NON un servizio esterno: il sistema
 * Template Etichette oggi chiama api.qrserver.com, dipendenza di rete che
 * romperebbe la stampa offline.
 */

// Sotto questa soglia qr-code-styling può lanciare "The canvas is too small"
// quando i dati richiedono molti moduli (URL lunghi) — stessa guardia di
// StyledQrCode.tsx
const MIN_RENDER_SIZE = 512;

export async function generateQrPngDataUrl(value: string, size = MIN_RENDER_SIZE): Promise<string> {
  const renderSize = Math.max(size, MIN_RENDER_SIZE);

  const qr = new QRCodeStyling({
    type: 'canvas',
    width: renderSize,
    height: renderSize,
    data: value,
    margin: 0,
    // 'M' basta per un'etichetta stampata su carta bianca e tiene il QR meno
    // fitto, quindi più leggibile a 25mm di lato
    qrOptions: { errorCorrectionLevel: 'M' },
    dotsOptions: { type: 'square', color: '#000000' },
    cornersSquareOptions: { type: 'square', color: '#000000' },
    cornersDotOptions: { type: 'square', color: '#000000' },
    backgroundOptions: { color: '#FFFFFF' },
  });

  const blob = await qr.getRawData('png');
  if (!blob) throw new Error('Generazione QR fallita');

  return await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('Lettura QR fallita'));
    reader.readAsDataURL(blob as Blob);
  });
}
